import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { DateIntervalFields, dateString, InputField, maxInputTextLength, FileForm } from '@mews-commander/legacy-form';
import { FieldsContainer } from '@mews-commander/ui';

const negotiatedRatesProps = {
    name: 'negotiatedRates',
    label: <LocalizedText textKey={TextKey.NegotiatedRates} />,
};

const contractStartDate = 'contractStartDate';
const contractEndDate = 'contractEndDate';

const contractStartDateProps = {
    name: contractStartDate,
    label: <LocalizedText textKey={TextKey.ContractStartDate} />,
};

const contractEndDateProps = {
    name: contractEndDate,
    label: <LocalizedText textKey={TextKey.ContractEndDate} />,
};

const dateConstraints = {
    contractStartDate: { dateString },
    contractEndDate: { dateString },
};

export const contractFieldsConstraints = {
    negotiatedRates: {
        length: maxInputTextLength,
    },
    ...dateConstraints,
};

interface ContractFieldsProps {
    accept?: string;
    editMode?: boolean;
}

export const ContractFields = ({ accept, editMode }: ContractFieldsProps) => (
    <FieldsContainer>
        <InputField {...negotiatedRatesProps} />
        <DateIntervalFields
            fieldNames={[contractStartDate, contractEndDate]}
            startProps={contractStartDateProps}
            endProps={contractEndDateProps}
            constraints={dateConstraints}
            inline
        />
        {editMode ? null : <FileForm accept={accept} required />}
    </FieldsContainer>
);
